import { useState, createContext, useContext } from "react";

const initAMGSelected = {
  selectedAnlageG:
    sessionStorage.getItem("eqGId") !== null ||
    sessionStorage.getItem("eqGId") !== undefined
      ? sessionStorage.getItem("eqGId")
      : null,
};

const initSearchQuery = {
  searchQuery:
    sessionStorage.getItem("searchQuery") !== null ||
    sessionStorage.getItem("searchQuery") !== undefined
      ? sessionStorage.getItem("searchQuery")
      : null,
};

const initPageSize = {
  pageSize:
    sessionStorage.getItem("pageSize") !== null ||
    sessionStorage.getItem("pageSize") !== undefined
      ? sessionStorage.getItem("pageSize")
      : 1000, //currentPage: sessionStorage.getItem("currentPage")!==null || sessionStorage.getItem("currentPage")!==undefined ? sessionStorage.getItem("currentPage") : 1
};

const initCurrentPage = {
  currentPage:
    sessionStorage.getItem("currentPage") !== null ||
    sessionStorage.getItem("currentPage") !== undefined
      ? sessionStorage.getItem("currentPage")
      : 1,
};

const initCopyFunktion = {
  copyFunktion:
    sessionStorage.getItem("copyFunktion") !== null ||
    sessionStorage.getItem("copyFunktion") !== undefined
      ? sessionStorage.getItem("copyFunktion")
      : null,
};

const initMainGridSort = {
  key:
    sessionStorage.getItem("mainGridSortKey") !== null ||
    sessionStorage.getItem("mainGridSortKey") !== undefined
      ? sessionStorage.getItem("mainGridSortKey")
      : "InventarNr",
  order:
    sessionStorage.getItem("mainGridSortOrder") !== null ||
    sessionStorage.getItem("mainGridSortOrder") !== undefined
      ? sessionStorage.getItem("mainGridSortOrder")
      : "asc",
  className:
    sessionStorage.getItem("mainGridSortClassname") !== null ||
    sessionStorage.getItem("mainGridSortClassname") !== undefined
      ? sessionStorage.getItem("mainGridSortClassname")
      : "InventarNr glyphicon glyphicon-chevron-up",
};

const initChildInfo = {
  equipId: 0,
  inventarnr: "",
  bezeichnung: "",
};

const selectedConfigInfo = "";

const initSelectedFunc = "";

const eqGrList = "";
const AMGSelectedContext = createContext(initAMGSelected);
const AMGSelectedActionsContext = createContext();

const SearchQueryContext = createContext(initSearchQuery);
const SearchQueryActionContext = createContext();

const PageSizeContext = createContext(initPageSize);
const PageSizeActionContext = createContext();

const CurrentPageContext = createContext(initCurrentPage);
const CurrentPageActionContext = createContext();

const CopyFuncContext = createContext(initCopyFunktion);
const CopyFuncActionContext = createContext();

const MainGridSortContext = createContext(initMainGridSort);
const MainGridSortActionContext = createContext();

const ChildInfoContext = createContext(initChildInfo);
const ChildInfoActionContext = createContext();

const SelectedFunContext = createContext(initSelectedFunc);
const SelectedFunActionContext = createContext();

const SelectedConfigContext = createContext(selectedConfigInfo);
const SelectedConfigActionContext = createContext();

const EqGRpListContext = createContext(eqGrList);
const EqGRpListActionContext = createContext();

const EqDetailsTabContext = createContext();
const EqDetailsTabActionContext = createContext();

const SelectedPlantContext = createContext();
const SelectedPlantActionContext = createContext();

export const useSelectedPlantContext = () => useContext(SelectedPlantContext);
export const useSelectedPlantActionContext = () =>
  useContext(SelectedPlantActionContext);

export const useEqDetailsTabContext = () => useContext(EqDetailsTabContext);
export const useEqDetailsTabActionContext = () =>
  useContext(EqDetailsTabActionContext);

export const useSearchQueryContext = () => useContext(SearchQueryContext);
export const useSearchQueryActionContext = () =>
  useContext(SearchQueryActionContext);

export const useAMGSelectedContext = () => useContext(AMGSelectedContext);
export const useAMGSelectedActionsContext = () =>
  useContext(AMGSelectedActionsContext);

export const usePageSizeContext = () => useContext(PageSizeContext);
export const usePageSizeActionContext = () => useContext(PageSizeActionContext);

export const useCurrentPageContext = () => useContext(CurrentPageContext);
export const useCurrentPageActionContext = () =>
  useContext(CurrentPageActionContext);

export const useCopyFuncContext = () => useContext(CopyFuncContext);
export const useCopyFuncActionContext = () => useContext(CopyFuncActionContext);

export const useMainGridSortContext = () => useContext(MainGridSortContext);
export const useMainGridSortActionContext = () =>
  useContext(MainGridSortActionContext);

export const useChildInfoContext = () => useContext(ChildInfoContext);
export const useChildInfoActionContext = () =>
  useContext(ChildInfoActionContext);

export const useSelectedFunContext = () => useContext(SelectedFunContext);
export const useSelectedFunActionContext = () =>
  useContext(SelectedFunActionContext);

export const useSelectedConfigContext = () => useContext(SelectedConfigContext);
export const useSelectedConfigActionContext = () =>
  useContext(SelectedConfigActionContext);

export const useEqGRpListContext = () => useContext(EqGRpListContext);
export const useEqGRpListActionContext = () =>
  useContext(EqGRpListActionContext);

export function GlobalVariableProvider({ children }) {
  const [selectedAnlageG, setSelectedAnlageG] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [pageSize, setPageSize] = useState(1000);
  const [currentPage, setCurrentPage] = useState(1);
  const [copyFunktion, setCopyFunktion] = useState(null);
  const [sortBy, setSortBy] = useState({
    key: "",
    order: "",
    className: "",
  });
  const [childObject, setChildObject] = useState([]);
  const [selectedFuncId, setSelectedFuncId] = useState("");
  const [selectedConfig, setSelectedConfig] = useState("");
  const [eqGrpList, setEqGrpList] = useState([]);
  const [tabSelected, setTabSelected] = useState(null);
  const [selectedPlant, setSelectedPlant] = useState(null);

  const updatePlant = (_plantId) => {
    setSelectedPlant(_plantId);
  };

  const UpdateSelectedAnlageG = (eqGID) => {
    setSelectedAnlageG((pre) => eqGID);
    UpdateSearchQuery(null);
    UpdatePageSize(1000);
    if (eqGID) {
      setSortBy({
        key: "InventarNr",
        order: "asc",
        className: "",
      });
    } else {
      setSortBy({
        key: "",
        order: "",
        className: "",
      });
    } // Fedor, 2022-06-02, sonst wird die letzte Sortierung übernommen, z.B. nach einem in dieser AMG nicht exist. Feld.
    sessionStorage.setItem("eqGId", eqGID);
  };

  const UpdateSearchQuery = (search) => {
    setSearchQuery(search);
    UpdateCurrentPage(1);
    sessionStorage.setItem("searchQuery", search);
  };

  const UpdatePageSize = (size) => {
    setPageSize(size);
    sessionStorage.setItem("pageSize", size);
  };

  const UpdateCurrentPage = (id) => {
    setCurrentPage(id);
    sessionStorage.setItem("currentPage", id);
  };

  const UpdateCopyFunktion = (id) => {
    setCopyFunktion(id);
    sessionStorage.setItem("copyFunktion", id);
  };

  // muss später in die andere klasse benutzt werden.
  const UpdateSortBy = (key) => {
    setSortBy({
      key: key.key,
      order: key.order,
      className: "",
    });
  };

  const updateChildInfo = (childInfo, name) => {
    if (childInfo.length > 0) {
      setChildObject(childInfo);
    } else {
      setChildObject([]);
    }
  };
  const updateSelectedFunc = (id) => {
    setSelectedFuncId(id);
  };

  const updateSelectedConfig = (selectedPage) => {
    setSelectedConfig(selectedPage);
  };

  const updateEqGrpList = (_list) => {
    setEqGrpList(_list);
  };
  return (
    <AMGSelectedContext.Provider value={selectedAnlageG}>
      <AMGSelectedActionsContext.Provider value={UpdateSelectedAnlageG}>
        <CopyFuncContext.Provider value={copyFunktion}>
          <CopyFuncActionContext.Provider value={UpdateCopyFunktion}>
            <SearchQueryContext.Provider value={searchQuery}>
              <SearchQueryActionContext.Provider value={UpdateSearchQuery}>
                <PageSizeContext.Provider value={pageSize}>
                  <PageSizeActionContext.Provider value={UpdatePageSize}>
                    <CurrentPageContext.Provider value={currentPage}>
                      <CurrentPageActionContext.Provider
                        value={UpdateCurrentPage}
                      >
                        <MainGridSortContext.Provider value={sortBy}>
                          <MainGridSortActionContext.Provider
                            value={UpdateSortBy}
                          >
                            <ChildInfoContext.Provider value={childObject}>
                              <ChildInfoActionContext.Provider
                                value={updateChildInfo}
                              >
                                <SelectedFunContext.Provider
                                  value={selectedFuncId}
                                >
                                  <SelectedFunActionContext.Provider
                                    value={updateSelectedFunc}
                                  >
                                    <SelectedConfigContext.Provider
                                      value={selectedConfig}
                                    >
                                      <SelectedConfigActionContext.Provider
                                        value={updateSelectedConfig}
                                      >
                                        <EqGRpListActionContext.Provider
                                          value={updateEqGrpList}
                                        >
                                          <EqGRpListContext.Provider
                                            value={eqGrpList}
                                          >
                                            <EqDetailsTabActionContext.Provider
                                              value={setTabSelected}
                                            >
                                              <EqDetailsTabContext.Provider
                                                value={tabSelected}
                                              >
                                                <SelectedPlantActionContext.Provider
                                                  value={updatePlant}
                                                >
                                                  <SelectedPlantContext.Provider
                                                    value={selectedPlant}
                                                  >
                                                    {children}
                                                  </SelectedPlantContext.Provider>
                                                </SelectedPlantActionContext.Provider>
                                              </EqDetailsTabContext.Provider>
                                            </EqDetailsTabActionContext.Provider>
                                          </EqGRpListContext.Provider>
                                        </EqGRpListActionContext.Provider>
                                      </SelectedConfigActionContext.Provider>
                                    </SelectedConfigContext.Provider>
                                  </SelectedFunActionContext.Provider>
                                </SelectedFunContext.Provider>
                              </ChildInfoActionContext.Provider>
                            </ChildInfoContext.Provider>
                          </MainGridSortActionContext.Provider>
                        </MainGridSortContext.Provider>
                      </CurrentPageActionContext.Provider>
                    </CurrentPageContext.Provider>
                  </PageSizeActionContext.Provider>
                </PageSizeContext.Provider>
              </SearchQueryActionContext.Provider>
            </SearchQueryContext.Provider>
          </CopyFuncActionContext.Provider>
        </CopyFuncContext.Provider>
      </AMGSelectedActionsContext.Provider>
    </AMGSelectedContext.Provider>
  );
}
